export const frontmatter = {
    "title": "Conceptos clave",
    "sidebar_group": "conceptos",
    "sidebar_label": "Conceptos",
    "sidebar_order": 3
}

export const toc = []